<template>
  <div style="height: 300px;">
    <canvas ref="canvas" />
  </div>
</template>

<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    labels: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  watch: {
    labels: 'render',
    data: 'render'
  },
  mounted () {
    this.render()
  },
  methods: {
    render () {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            label: 'Revenue',
            data: this.data,
            borderColor: '#000',
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
            borderWidth: 2,
            fill: true,
            pointRadius: 4,
            pointBackgroundColor: '#000',
            tension: 0.3
          }
        ]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: { display: false },
            ticks: { fontColor: '#333', fontSize: 11 }
          }],
          yAxes: [{
            gridLines: { color: '#eee' },
            ticks: {
              beginAtZero: true,
              fontColor: '#333',
              callback: value => `$${value}`
            }
          }]
        },
        legend: { display: false },
        tooltips: {
          callbacks: {
            label: tooltipItem => `$${tooltipItem.yLabel}`
          }
        }
      })
    }
  }
}
</script>
